export default {
      id: "telegram-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#telegram",
      toString: function () {
        return this.url;
      }
    }